var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1Dark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 244.606,
    height: 66,
    viewBox: "0 0 244.606 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(-742.394 -767)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Calificaciones_Digitales",
    "data-name": "CalificacionesDigitales",
    transform: "translate(821 796)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Calificaciones"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "Digitales")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(-251.328 17.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    transform: "translate(1001.895 757.876)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.041,
    cy: 24.041,
    r: 24.041,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.041,
    cy: 24.041,
    r: 23.541,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5166988",
    "data-name": 5166988,
    transform: "translate(993.722 749.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M52.211-490.686a32.666,32.666,0,0,0-17.785,6.576,41.341,41.341,0,0,0-6.2,6.218,32.238,32.238,0,0,0-5.86,12.822,28.428,28.428,0,0,0-.662,6.687c0,1.324.069,3.033.165,3.791a33.234,33.234,0,0,0,6.852,16.365,45.047,45.047,0,0,0,5.129,5.129A32.642,32.642,0,0,0,49.8-426.314a40.838,40.838,0,0,0,8,.069A32.794,32.794,0,0,0,73.374-432.5a42.318,42.318,0,0,0,5.915-5.722,31.99,31.99,0,0,0,7.018-20.157,31.99,31.99,0,0,0-7.018-20.157,42.235,42.235,0,0,0-5.846-5.68,33.492,33.492,0,0,0-8.934-4.757A33.074,33.074,0,0,0,52.211-490.686Zm2.7,13.594c.165.165,1.558,2.537,3.088,5.267s2.813,4.991,2.84,5.018,2.606.565,5.735,1.2,5.832,1.213,6.011,1.3a1.282,1.282,0,0,1,.524.648.943.943,0,0,1,.028.951,61.8,61.8,0,0,1-4.067,4.674c-3.061,3.323-3.9,4.315-3.9,4.591,0,.207.29,2.868.634,5.915.551,4.77.62,5.611.469,5.97a1.482,1.482,0,0,1-1.227.827c-.152,0-2.688-1.117-5.653-2.468l-5.377-2.468L48.626-443.2c-2.964,1.351-5.515,2.468-5.666,2.468a1.482,1.482,0,0,1-1.227-.827c-.152-.358-.083-1.2.469-5.97.345-3.047.634-5.708.634-5.915,0-.276-.841-1.268-3.888-4.591-2.151-2.316-3.984-4.412-4.081-4.646a1.379,1.379,0,0,1,.427-1.558c.165-.1,2.854-.689,5.984-1.324s5.735-1.172,5.8-1.213S48.474-469.1,50-471.825s2.9-5.074,3.019-5.225A1.275,1.275,0,0,1,54.913-477.092Z",
    transform: "translate(-21.7 490.748)",
    fill: "#eb0846"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1Dark);
export default __webpack_public_path__ + "static/media/logo-1-dark.5096351151a92aef64805e793923c7b3.svg";
export { ForwardRef as ReactComponent };